export const LOGIN_STATE_AUTH_POPUP = 'auth'
export const LOGIN_STATE_EMAIL_POPUP = 'email'
export const LOGIN_STATE_EMAIL_SUCCESS_POPUP = 'email_success'
export const LOGIN_STATE_PASSWORD_POPUP = 'password'
export const LOGIN_STATE_UNLINK_POPUP = 'unlink'

export const UNLINK_POPUP_PAGE_INFO = 'info'
export const UNLINK_POPUP_PAGE_VERIFICATION = 'verification'
export const UNLINK_POPUP_PAGE_SET_PASSWORD = 'set_password'

export const TRANSFER = 'transfer'
export const DISBAND = 'disband'
export const LEAVE = 'leave'

export const REQUEST_STATUS_PENDING = 'pending'
export const REQUEST_STATUS_COMPLETED = 'completed'
export const REQUEST_STATUS_SUCCESS = 'success'
export const REQUEST_STATUS_INITIAL = 'initial'

export const SMS_LEGAL_DISCLAIMER_MAX_LENGTH = 250
